import { Card, styled, Flex } from '@grupoboticario/flora-react';

import { Divider } from 'components';

const styles = {
  Detail: styled(Flex, {
    width: '100%',
  }),

  Divider: styled(Divider, {
    margin: '$2 0',
  }),

  FixedToast: styled(Card, {
    background: '$backgroundAltSecondary',
    color: '$nonInteractiveAltPredominant',

    '&[data-card]': {
      cursor: 'initial',
    },
  }),

  Tag: styled(Flex, {
    background: '$light-dark-1',
    borderRadius: '$small',
    color: '$dark-dark',
    padding: '$2',
    alignItems: 'center',
    width: '100%',

    '& svg': {
      marginRight: '$2',
    },
  }),
};

export default styles;
